import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';

import { loc } from '../../lib/loc';
import { RegisterLoc } from '../../loc/register';
import { useStores } from '../../hooks/use-stores';

import ErrorMessage from '../../interface/ErrorMessage';
import PreloadButton from '../../interface/PreloadButton';
import InputWithCountrySelect from '../UI/InputWithCountrySelect';
import CityAutocomplete from './CityAutocomplete';

const Input = props => <input className="legal-form__input" required {...props} />;

const NewLegalRegisterForm = observer(() => {
    const [phone, setPhone] = useState('');

    const {
        RegisterStore: { loaderRegister, errorMessage, token, selectValue, setPlaceholder, handleChange, registerLegalNew, getCities } = {},
    } = useStores();

    const register = e => {
        e.preventDefault();
        if (!phone) return;
        registerLegalNew(e, phone);
    };

    useEffect(() => getCities(), [getCities]);

    return (
        <form onSubmit={register} autoComplete="off">
            {token && <Redirect to={{ pathname: '/register/complete/', state: { token } }} />}
            {errorMessage && <ErrorMessage message={errorMessage} />}
            <select style={{ width: '100%' }} className="login-form__input" name="country" value={selectValue} onChange={handleChange}>
                <option value={loc(RegisterLoc.country.russia)}>{loc(RegisterLoc.country.russia)}</option>
                <option value={loc(RegisterLoc.country.belarus)}>{loc(RegisterLoc.country.belarus)}</option>
                <option value={loc(RegisterLoc.country.kazakhstan)}>{loc(RegisterLoc.country.kazakhstan)}</option>
            </select>
            <Input name="name" placeholder={loc(RegisterLoc.form.companyName)} />
            <Input name="tin" placeholder={setPlaceholder()} />

            <CityAutocomplete />

            <textarea
                style={{ width: '100%' }}
                className="login-form__input"
                name="address"
                placeholder={loc(RegisterLoc.form.legalAddress)}
                required
            />
            <Input name="contact_name" placeholder={loc(RegisterLoc.form.contactName)} />

            <InputWithCountrySelect setPhone={setPhone} placeholder={loc(RegisterLoc.form.phoneNumber)} />

            <Input type="email" name="contact_email" placeholder={loc(RegisterLoc.form.email)} />

            <div className="legal-form__wrap-btn">
                <PreloadButton className="legal-form__btn" isLoad={loaderRegister}>
                    {loc(RegisterLoc.button)}
                </PreloadButton>
            </div>
        </form>
    );
});

export default NewLegalRegisterForm;
